module.exports = __webpack_public_path__ + "img/poetsinstructie-aangepast.329e8bc0.png";